import type { CampaignDetailModelState, ContractAdminModel } from '@urbanx/agx.campaigns.client';
import { ContractCompletionType } from '@urbanx/agx.campaigns.client';
import { AustralianState, NswContractStage, QldContractStage } from '@urbanx/agx-ui-components';

type CampaignState = CampaignDetailModelState | AustralianState;

const ValidQldStages: readonly QldContractStage[] = [
  QldContractStage.Accepted,
  QldContractStage.Unconditional,
  QldContractStage.Terminated,
  QldContractStage.Settled,
  QldContractStage.BackUp,
  QldContractStage.PendingCompliance,
];

const ValidNswSalesAdviceStages: readonly NswContractStage[] = [
  NswContractStage.ContractRequested,
  NswContractStage.AwaitingExchange,
];

const ValidNswStages: readonly NswContractStage[] = [
  NswContractStage.PendingCompliance,
  NswContractStage.Accepted,
  NswContractStage.Unconditional,
  NswContractStage.Settled,
  NswContractStage.Terminated,
  NswContractStage.Cancelled,
];

export function filterContractsForCampaignState(
  contracts: ContractAdminModel[],
  campaignState?: CampaignState
): ContractAdminModel[] {
  if (campaignState === AustralianState.NSW)
    return contracts.filter((contract) => {
      const stage = contract.stage as NswContractStage;

      if (ValidNswSalesAdviceStages.includes(stage))
        return contract.contractCompletionType === ContractCompletionType.SalesAdvice;

      return ValidNswStages.includes(stage);
    });

  if (campaignState === AustralianState.QLD)
    return contracts.filter((contract) =>
      ValidQldStages.includes(contract.stage as QldContractStage)
    );

  return [];
}
